/**
 * The one SVG frame every pictogram in the product is drawn in.
 *
 * `chrome/BrandIcons` and `plants/PlantIcons` each carried their own copy of
 * this, byte for byte, and their header comments both said "same contract as the
 * other" — which is a comment doing a module's job. The two sets are separate
 * because they are edited for different reasons, not because they are drawn
 * differently, and the frame is the part that must never diverge: a 20px glyph
 * from one file has to sit on the same optical baseline as a 20px glyph from the
 * other when they land in the same row.
 *
 * `fill="none"` with a `currentColor` stroke is what lets a caller tint a glyph
 * and its label from a single token. A path that wants a fill sets it on the
 * path — `LeafIcon` is the one that does.
 *
 * `aria-hidden`, always: every glyph in this product ships beside its own text
 * label and is never the only carrier of a fact.
 */
export default function Icon({ children, size = 24, ...rest }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
            {...rest}
        >
            {children}
        </svg>
    );
}
